<div class="ultra">
	<div class="ibar" id="ibar">
		<div class="ipiece">
			<div class="call">
	        	<img class="sicon" src="../../../../assets/img/sicon.svg" alt="chat">
	        </div>
			<div class="wtitle">
				<h3>{{ 'cloud.title366' | translate }}</h3>
			</div>
			<div class="sim-button button14">
	            <span>{{ 'cloud.title367' | translate }}</span>
	            <img class="arrow22" src="../../../assets/img/blueArrow.svg" alt="blue arrow">
	            <img class="warrow22" src="../../../../assets/img/arrow.svg" alt="arrow">
	        </div>
		</div>
	</div>
</div>

